export const LocalStorageKeys = {
  imported_tokens: 'imported-tokens',
};
